import { Button } from '@givebutter/primitives/button';
import {
    faChartPie,
    faDiagramSubtask,
    faEnvelopesBulk,
    faFileChartColumn,
    faListCheck,
    faMagicWandSparkles,
    faMobileButton,
    faSoap,
    faUpload,
} from '@fortawesome/pro-thin-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    LETTER_START_COST,
    PLUS_LETTER_START_COST,
} from 'assets/js/pages/engage/letters/constants';
import { PLUS_MARKETING_LINK } from 'constants/links';
import PlusGradient from 'images/gbp-gradient.webp';
import DarkerGrainBg from 'images/gbp-grain-darker.png';
import GivebutterPlusLogo from 'images/givebutter-plus-logo.svg';

const SubscriptionPlusCallout = () => {
    return (
        <div
            className="flex flex-col gap-4 rounded-2xl border border-gray-300 p-8 shadow-sm"
            style={{
                background: `url("${PlusGradient}") no-repeat center center / cover, url("${DarkerGrainBg}") repeat`,
            }}
        >
            <div className="flex flex-col gap-2">
                <img className={'max-w-40'} src={GivebutterPlusLogo} alt="Givebutter Plus logo" />
                <div className="text-lg">
                    Explore the full spread of Givebutter features for a better way to work...
                </div>
            </div>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div className="flex items-center gap-3 font-medium">
                    <div
                        className={
                            'bg-gbp-gradient-1 flex size-10 items-center justify-center rounded-lg'
                        }
                    >
                        <FontAwesomeIcon icon={faDiagramSubtask} />
                    </div>
                    Workflows
                </div>
                <div className="flex items-center gap-3 font-medium">
                    <div
                        className={
                            'bg-gbp-gradient-1 flex size-10 items-center justify-center rounded-lg'
                        }
                    >
                        <FontAwesomeIcon icon={faChartPie} />
                    </div>
                    Expanded data visualizations
                </div>
                <div className="flex items-center gap-3 font-medium">
                    <div
                        className={
                            'bg-gbp-gradient-3 flex size-10 items-center justify-center rounded-lg'
                        }
                    >
                        <FontAwesomeIcon icon={faListCheck} />
                    </div>
                    Task management
                </div>
                <div className="flex items-center gap-3 font-medium">
                    <div
                        className={
                            'bg-gbp-gradient-3 flex size-10 items-center justify-center rounded-lg'
                        }
                    >
                        <FontAwesomeIcon icon={faEnvelopesBulk} />
                    </div>

                    <span>
                        Discounted direct mail (
                        <span className="line-through">${LETTER_START_COST}</span> $
                        {PLUS_LETTER_START_COST})
                    </span>
                </div>
                <div className="flex items-center gap-3 font-medium">
                    <div
                        className={
                            'bg-gbp-gradient-1 flex size-10 items-center justify-center rounded-lg'
                        }
                    >
                        <FontAwesomeIcon icon={faFileChartColumn} />
                    </div>
                    Custom reports
                </div>
                <div className="flex items-center gap-3 font-medium">
                    <div
                        className={
                            'bg-gbp-gradient-2 flex size-10 items-center justify-center rounded-lg'
                        }
                    >
                        <FontAwesomeIcon icon={faMagicWandSparkles} />
                    </div>
                    Advanced email editor
                </div>
                <div className="flex items-center gap-3 font-medium">
                    <div
                        className={
                            'bg-gbp-gradient-3 flex size-10 items-center justify-center rounded-lg'
                        }
                    >
                        <FontAwesomeIcon icon={faMobileButton} />
                    </div>
                    <span>Texting</span>
                </div>
                <div className="flex items-center gap-3 font-medium">
                    <div
                        className={
                            'bg-gbp-gradient-3 flex size-10 items-center justify-center rounded-lg'
                        }
                    >
                        <FontAwesomeIcon icon={faSoap} />
                    </div>
                    Data hygiene
                </div>
                <div className="flex items-center gap-3 font-medium">
                    <div
                        className={
                            'bg-gbp-gradient-1 flex size-10 items-center justify-center rounded-lg'
                        }
                    >
                        <FontAwesomeIcon icon={faUpload} />
                    </div>
                    File uploads
                </div>
            </div>
            <div>
                <a
                    href={PLUS_MARKETING_LINK}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-block"
                >
                    <Button variant="outline" color="neutral" size="sm">
                        Learn more
                    </Button>
                </a>
            </div>
        </div>
    );
};

export { SubscriptionPlusCallout };
